import React from 'react'
import { connect } from 'react-redux'
import ui from 'redux-ui'

import { Menu, Button, Icon } from 'semantic-ui-react'

import { Popup, Modal } from 'semantic-ui-react-with-store'

import { sendEmail } from 'actions/send_email'

import { newEntityFromApi } from 'actions/entities'

import NewEntityModal from 'components/entities/NewEntityModal'
import EmailCommunicationForm from 'components/email_communications/EmailCommunicationForm'

class SendEmailItem extends  React.Component {
  SubmitButton = (props) => {
    return(<Modal.Actions>
      <Button color='red' inverted onClick={ (event, data) => {props.onCancel()}} > <Icon name='close' /> {I18n.t('components.entities_list.cancel')}
      </Button>
      <Button.Group color='green'>
        <Button color='green' onClick={ (event, data) => {props.submit()}} >
          <Icon name='send' /> {I18n.t('components.send_email_item.submit')}
        </Button>
      </Button.Group>
    </Modal.Actions>)
  }

  render() {
    const { invoice } = this.props
    const dossier = invoice.dossier
    var message
    if (dossier) {
      if (invoice.proposed) {
        return <span></span>
      } else {
        message = invoice.sendInvoiceWarning
      }
    }

    if (message) {
      if (invoice.emailCommunications) {
        return <span>
          <Popup trigger={<Menu.Item icon='mail outline' />} header={I18n.t(`components.pdf_item.error.${message}`)}/>
        </span>
      }
      else {
        console.log(message)
        return <span>
          <Popup trigger={<Menu.Item icon='send' />} header={I18n.t(`components.pdf_item.error.${message}`)}/>
        </span>
      }
    } else {
      let Trigger = null
      if (invoice.emailCommunications) {

        Trigger = ((props) => <Modal trigger={<Menu.Item icon='send' />} open={this.props.ui.isEmailPopupVisible} onOpen={() => this.props.updateUI('isEmailPopupVisible', true)} onClose={() => this.props.updateUI('isEmailPopupVisible', false)} on='click'>
            <Modal.Header>
              {I18n.t('components.invoice.confirm_mail_info')}
            </Modal.Header>
            <Modal.Actions>
             <Button color='green' onClick={() => { props.onClick(); this.props.updateUI('isEmailPopupVisible', false) }} content={I18n.t('components.invoice.confirm_mail')}/>
            </Modal.Actions>
          </Modal>
          )
      } else {
        Trigger = ((props) => <Menu.Item icon='mail outline' {...props}/> )
      }
      return <NewEntityModal entityName='emailCommunication' form={EmailCommunicationForm} modalEntityId={this.props.ui.modalEntityId} trigger={Trigger} SubmitButton={this.SubmitButton} createEntityWithDefaults={this.props.newEmailCommunication}/>
    }
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { invoice } =  ownProps

  let emailCommunicationType = invoice.paid ? "invoice" : "invoice_unpaid"
  return {
    newEmailCommunication: () => {
      let communicationId = dispatch(newEntityFromApi('emailCommunication', { relationships: {}, attributes: { emailCommunicationType: emailCommunicationType, dossierId: invoice.dossier.id, invoiceId: invoice.id }}))
      return communicationId
    }
  };
}

export default connect(null, mapDispatchToProps)(ui({ state: { isEmailPopupVisible: false, modalEntityId: null } })(SendEmailItem));
